/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Zatím se nerozlišuje mezi zdrojem na kterém byla klávesa stisknuta.
// - Přidat další číselník ControlSource.
// - Příklady: HW klávesnice, virtuální klávesnice, dálkový ovladač, na zařízení, ...
/**
 * Číselník ovládacích tlačítek.
 * Jména převzata ze standardních hodnot podle MDN:
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
 * @enum {string}
 */
const ControlButton = {
  /** Šipka dolů. */
  ArrowDown: 'ArrowDown',
  /** Šipka vlevo. */
  ArrowLeft: 'ArrowLeft',
  /** Šipka vpravo. */
  ArrowRight: 'ArrowRight',
  /** Šipka nahoru. */
  ArrowUp: 'ArrowUp',
  /**
   * Tlačítko pro návrat zpět v historii.
   * Na standardní klávesnici se většinou nenachází.
   * Na dálkových ovladačích je to tlačítko se šipkou zpět.
   * Typické je také jako HW tlačítko na Android.
   */
  Back: 'Back',
  /**
   * Tlačítko pro potvrzení zadání.
   * Na klávesnicích je to klávesa enter.
   * Na dálkových ovladačích je to tlačítko umístěné mezi šipkami.
   */
  Enter: 'Enter'
};

export default ControlButton;
